import { useMemo } from 'react'
import { eachWeekOfInterval } from 'date-fns'
import { fr } from 'date-fns/locale'

/**
 * Compute the list of week start dates for a given [start, end] date interval.
 * - Returns undefined when inputs are missing or invalid.
 * - Weeks start on Monday (fr locale), aligning with payroll usage.
 */
export function useWeeksInInterval(start?: Date, end?: Date): Date[] | undefined {
  return useMemo(() => {
    if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return undefined
    }
    try {
      return eachWeekOfInterval({ start, end }, { locale: fr, weekStartsOn: 1 })
    } catch {
      return undefined
    }
  }, [start, end])
}
